// Información de build generada automáticamente
export const BUILD_DATE = '21-11-2025 14:57:55';
export const BUILD_HASH = '1mqmqmitoja';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1763747875785;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '21-11-2025 14:57:55',
  buildHash: '1mqmqmitoja',
  appVersion: '0.0.0',
  timestamp: 1763747875785
});
